"use client";
import { FC } from "react";

import getYouTubeID from "get-youtube-id";
import { stegaClean } from "next-sanity";

import dynamic from "next/dynamic";

const LiteYouTubeEmbed = dynamic(() => import("react-lite-youtube-embed"));
interface CaseVideoProps {
  squareFormat?: boolean;
  title: string;
  url: string;
}
const CaseVideo: FC<CaseVideoProps> = ({
  squareFormat = false,
  title,
  url,
}) => {
  return (
    <LiteYouTubeEmbed
      id={getYouTubeID(stegaClean(url)) as string}
      title={title}
      wrapperClass={`yt-lite ${squareFormat ? " aspect-square" : ""}`}
    />
  );
};

export default CaseVideo;
